declare let $: any;

export class BaseModel {
  constructor(input: any = null) {
    if (input) {
      Object.assign(this, input);
    }
  }

  public static mapModels(input: any[]) {
    const models = [];
    input.forEach((model) => {
      models.push(new this(model));
    });
    return models;
  }

  public static map(input: any) {
    return new this(input);
  }

  public update(input: any) {
    for (const i in input) {
      // if (this.hasOwnProperty(i)) {
      //   this[i] = input[i];
      // }
      if (input[i]) {
        this[i] = input[i];
      }
    }
  }

  public clone(deep: boolean = false) {
    const data = deep ? $.extend({}, this) : this;
    return new (<any>this.constructor)(data);
  }
}
